import { Link } from "react-router-dom";
import { BrandLockup } from "@/shell/CandidateFlow";

const sections = [
  {
    title: "1. Beta programme",
    body: "Executive Interview Coach is currently in a closed private beta. Access is granted by invitation only. We reserve the right to modify, suspend, or terminate access at any time without notice during the beta period.",
  },
  {
    title: "2. Use of the service",
    body: "You may only use Executive Interview Coach for lawful purposes in connection with executive search and candidate interview preparation. You must not use the service to generate misleading content, to harm any individual, or in violation of applicable law.",
  },
  {
    title: "3. Intellectual property",
    body: "All content, designs, and software within Executive Interview Coach are the intellectual property of Andrew Akuffo, trading as Executive Interview Coach. You may not reproduce, distribute, or create derivative works without prior written consent.",
  },
  {
    title: "4. Data",
    body: "Candidate session data, CVs, and interview transcripts are processed to provide the coaching service. By using the service, you confirm you have the necessary consents to submit candidate data. See our Privacy Policy for full details.",
  },
  {
    title: "5. AI-generated feedback",
    body: "Scores, scorecards and coaching feedback are generated by AI for interview practice. They can be wrong. They must not be used as the sole basis for any hiring decision. Recruiting firms remain responsible for their own hiring decisions and for offering candidates a human review on request.",
  },
  {
    title: "6. Limitation of liability",
    body: "To the maximum extent permitted by applicable law, Andrew Akuffo, trading as Executive Interview Coach, shall not be liable for any indirect, incidental, or consequential damages arising from use of the service.",
  },
  {
    title: "7. Governing law",
    body: "These terms are governed by the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.",
  },
  {
    title: "8. Changes",
    body: "We may update these terms from time to time. Continued use of the service after changes constitutes acceptance of the revised terms.",
  },
  {
    title: "9. Contact",
    body: "Questions about these terms should be directed to: legal@executiveinterview.coach",
  },
];

export function Terms() {
  return (
    <div style={{ background: "#FBFAFE", minHeight: "100vh", fontFamily: "'Inter', system-ui, sans-serif" }}>
      <header style={{ borderBottom: "1px solid #EFEBF7", padding: "20px 40px", display: "flex", alignItems: "center", gap: 10 }}>
        <Link to="/" style={{ textDecoration: "none" }}>
          <BrandLockup />
        </Link>
      </header>
      <main style={{ maxWidth: 680, margin: "0 auto", padding: "60px 24px 80px" }}>
        <div style={{ fontFamily: "ui-monospace, monospace", fontSize: 10, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase" as const, color: "#7A6BE0", marginBottom: 16 }}>
          Legal
        </div>
        <h1 style={{ fontSize: 32, fontWeight: 700, color: "#17131F", marginBottom: 8, letterSpacing: "-0.02em" }}>Terms of Service</h1>
        <p style={{ fontSize: 13, color: "#7C7590", marginBottom: 48 }}>Last updated: 2 October 2026</p>
        {sections.map(({ title, body }) => (
          <section key={title} style={{ marginBottom: 36 }}>
            <h2 style={{ fontSize: 16, fontWeight: 600, color: "#17131F", marginBottom: 10 }}>{title}</h2>
            <p style={{ fontSize: 15, lineHeight: 1.7, color: "#4A4260" }}>{body}</p>
          </section>
        ))}
      </main>
      <footer style={{ borderTop: "1px solid #EFEBF7", padding: "20px 40px", display: "flex", gap: 20 }}>
        <Link to="/" style={{ fontFamily: "ui-monospace, monospace", fontSize: 10, color: "#7C7590", textDecoration: "none", letterSpacing: "0.06em" }}>Home</Link>
        <Link to="/privacy" style={{ fontFamily: "ui-monospace, monospace", fontSize: 10, color: "#7C7590", textDecoration: "none", letterSpacing: "0.06em" }}>Privacy Policy</Link>
      </footer>
    </div>
  );
}
